import { dataPause } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPause = /*#__PURE__*/createIcon(dataPause)
export default IconPause
